export default __webpack_public_path__ + "static/media/website-2.f67b20dc.jpg";